import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@lib/components/Modal/Modal';
import TextEditor from '@lib/components/TextEditor/TextEditor';
import styles from './DocumentVersionNotes.module.scss';

interface DocumentVersionNotesProps {
  isOpen: boolean;
  notes: string;
  onClose: () => void;
}

export default function DocumentVersionNotes({
  isOpen,
  notes,
  onClose,
}: DocumentVersionNotesProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} caption={t('version-notes')} onClose={onClose}>
      <div className={styles.versionNotesContent}>
        <TextEditor
          className={styles.textEditor}
          readOnly
          useCollapse={false}
          value={notes}
        />
      </div>
    </Modal>
  );
}
